// extracted by mini-css-extract-plugin
export default {"wrapper":"Anchor_wrapper__SEYZP"};